/*
 * cart-remove-tracking.js
 * ---------------------------------------------------------------------------
 * Pushes a `taggrs_remove_from_cart` dataLayer event when a cart line item is
 * removed, so the removal reliably reaches GTM (and the Spotler RemoveFromCart
 * tag). TAGGRS does not emit a remove event by itself.
 *
 * The event mirrors the taggrs_add_to_cart ecommerce schema (currency / value /
 * items[]); the Spotler tag reads {{ecommerce.items}}. See
 * performance/js-execution/gtm-spotler-taggrs-migratie.md.
 *
 * Behaviour per context (Impact theme, theme.js.liquid LineItemQuantity):
 *   - Drawer / other: Impact removes via AJAX without navigating, so we only
 *     push the event and let Impact handle removal + UI (counts, totals).
 *   - /cart page: Impact does a full page navigation, which can cut off the
 *     event before it flushes. There we take over: push, remove via AJAX, then
 *     reload (same end result as before). Falls back to the native link on any
 *     error, so an item is always removable.
 */
(function () {
  'use strict';

  function toNumber(value) {
    var n = parseInt(value, 10);
    return isNaN(n) ? null : n;
  }

  function buildItem(el) {
    var variantId = toNumber(el.getAttribute('data-variant-id'));
    var priceCents = toNumber(el.getAttribute('data-price-cents')) || 0;
    return {
      id: variantId,
      item_id: toNumber(el.getAttribute('data-product-id')),
      variant_id: variantId,
      sku: el.getAttribute('data-sku') || '',
      item_name: el.getAttribute('data-item-name') || '',
      title: el.getAttribute('data-variant-title') || '',
      price: priceCents / 100,
      quantity: toNumber(el.getAttribute('data-quantity')) || 0
    };
  }

  function pushRemoveEvent(link) {
    var lineTotalCents = toNumber(link.getAttribute('data-line-total-cents')) || 0;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'taggrs_remove_from_cart',
      ecommerce: {
        currency: link.getAttribute('data-currency') || '',
        value: lineTotalCents / 100,
        items: [buildItem(link)]
      }
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) {
        return;
      }
      var link = target.closest('a[data-taggrs-remove]');
      if (!link) {
        return;
      }

      // Always record the removal.
      pushRemoveEvent(link);

      var settings = window.themeVariables && window.themeVariables.settings;
      var isCartPage = settings && settings.pageType === 'cart';
      if (!isCartPage) {
        // Drawer / other: let Impact's AJAX handler remove + re-render in place.
        return;
      }

      // Cart page: pre-empt Impact's full-page navigation so the event flushes.
      event.preventDefault();
      event.stopImmediatePropagation();

      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: link.getAttribute('data-line-key'), quantity: 0 })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('cart/change.js responded ' + response.status);
          }
          window.location.reload();
        })
        .catch(function () {
          window.location.href = link.href; // fallback: native removal
        });
    },
    true // capture phase — runs before Impact's bubble-phase handler
  );
})();
